import { render, staticRenderFns } from "./examineHistory.vue?vue&type=template&id=95c5ca3c"
import script from "./examineHistory.vue?vue&type=script&lang=js"
export * from "./examineHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95c5ca3c')) {
      api.createRecord('95c5ca3c', component.options)
    } else {
      api.reload('95c5ca3c', component.options)
    }
    module.hot.accept("./examineHistory.vue?vue&type=template&id=95c5ca3c", function () {
      api.rerender('95c5ca3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/examineHistory.vue"
export default component.exports